import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { DeploymentModule } from '../deployment/deployment.module';
import { NodeDetailsComponent } from './components/node-details/node-details.component';
import { NodeLeftPanelComponent } from './components/node-left-panel/node-left-panel.component';
import { NodeListComponent } from './components/node-list/node-list.component';
//import { NodeLogsComponent } from './components/node-logs/node-logs.component';
import { NodeMainPanelComponent } from './components/node-main-panel/node-main-panel.component';
import { NodeParentListComponent } from './components/node-parent-list/node-parent-list.component';
import { NodeRoutingModule } from './node-routing.module';
import { AddNodeComponent } from './modals/add-node/add-node.component';
import { NodeactionConfirmComponent } from './modals/nodeaction-confirm/nodeaction-confirm.component';
import { ScaleConfirmationComponent } from './modals/scale-confirmation/scale-confirmation.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NodeNetworkComponent } from './components/node-network/node-network.component';
import { SetNodegroupVmComponent } from './modals/set-nodegroup-vm/set-nodegroup-vm.component';
import { AllNodesListComponent } from './components/all-nodes-list/all-nodes-list.component';
import { AttachDeploymentComponent } from './modals/attach-deployment/attach-deployment.component';
import { AttachGatewayComponent } from './components/node-network/modals/attach-gateway/attach-gateway.component';
import { DetachGatewayComponent } from './components/node-network/modals/detach-gateway/detach-gateway.component';
import { SharedModule } from '../shared/shared.module';
import { DynamicWorkstationComponent } from './modals/dynamic-workstation/dynamic-workstation.component';
import { ImportNodesComponent } from './modals/import-nodes/import-nodes.component';
import { UpdateNodeComponent } from './modals/update-node/update-node.component';
import { ResizableModule } from '../../core/directive/resizable/resizable.module';
import { AttachNodeComponent } from './modals/attach-node/attach-node.component';
import { NodeReportsComponent } from './modals/node-reports/node-reports.component';
import { NgChartsModule } from 'ng2-charts';
import { DetachNodesComponent } from './modals/detach-nodes/detach-nodes.component';
import { EditColoumsComponent } from './modals/edit-coloums/edit-coloums.component';
import { NodeGpuComponent } from './components/node-gpu/node-gpu.component';
import { ManageGpuInstancesComponent } from './modals/manage-gpu-instances/manage-gpu-instances.component';
import { AttachVGPUComponent } from './modals/attach-v-gpu/attach-v-gpu.component';
import { RemoveSessionComponent } from './modals/remove-session/remove-session.component';
import { UpdateBmNodeComponent } from './modals/update-bm-node/update-bm-node.component';
import { ResizeNodeComponent } from './modals/resize-node/resize-node.component';
import { AddNodeFromTemplateComponent } from './modals/add-node-from-template/add-node-from-template.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularSplitModule } from 'angular-split';
import { NodeAdvanceViewComponent } from './components/node-advance-view/node-advance-view.component';
import { DynamicPaginationDirective } from 'src/app/core/directive/dynamicPagination/dynamic-pagination.directive';
import { PodInfoComponent } from './components/pod-info/pod-info.component';
import { PodAdvanceViewComponent } from './components/pod-advance-view/pod-advance-view.component';
import { SyncNodesComponent } from './modals/sync-nodes/sync-nodes.component';
import { CreatePodDialogComponent } from './modals/create-pod-dialog/create-pod-dialog.component';
import { CodeServerFormComponent } from './modals/code-server-form/code-server-form.component';


@NgModule({
  exports: [
  ],
  declarations: [
    NodeDetailsComponent,
    NodeLeftPanelComponent,
    NodeListComponent,
    //NodeLogsComponent,
    NodeMainPanelComponent,
    NodeParentListComponent,
    NodeMainPanelComponent,
    AddNodeComponent,
    NodeactionConfirmComponent,
    ScaleConfirmationComponent,
    NodeNetworkComponent,
    SetNodegroupVmComponent,
    AllNodesListComponent,
    AttachGatewayComponent,
    DetachGatewayComponent,
    AttachDeploymentComponent,
    DynamicWorkstationComponent,
    ImportNodesComponent,
    UpdateNodeComponent,
    AttachNodeComponent,
    NodeReportsComponent,
    DetachNodesComponent,
    EditColoumsComponent,
    NodeGpuComponent,
    ManageGpuInstancesComponent,
    AttachVGPUComponent,
    UpdateBmNodeComponent,
    RemoveSessionComponent,
    ResizeNodeComponent,
    AddNodeFromTemplateComponent,
    NodeAdvanceViewComponent,
    PodInfoComponent,
    PodAdvanceViewComponent,
    SyncNodesComponent,
    CreatePodDialogComponent,
    CodeServerFormComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    NgxPaginationModule,
    SharedModule,
    NgxSpinnerModule,
    NodeRoutingModule,
    CoreModule,
    NgbModule,
    SharedModule,
    NgbModule,
    NgSelectModule,
    ResizableModule,
    NgChartsModule,
    AngularSplitModule,
    DynamicPaginationDirective
  ]
})
export class NodeModule { }
